'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import newStarterActions from 'actions/NewStarterActionCreators';
import newStarterStore from 'stores/NewStarterStore';
import PageSection from 'components/base/PageSection';
import WidgetCount from 'components/base/WidgetCount';
import WidgetHeading from 'components/base/WidgetHeading';

import _ from 'underscore';
import utils from 'services/utils';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class NewStartersWidget extends React.Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            count: 0,
        };
    }

    componentDidMount() {
        newStarterStore.addChangeActionsCountListener(this.onChange);

        setTimeout(function () {
            newStarterActions.getActionsCount();
        }, 0);
    }

    componentWillUnmount() {
        newStarterStore.removeChangeActionsCountListener(this.onChange);
    }

    onChange() {
        const status = newStarterStore.getNewStarterActionsCount();

        this.setState({
            count: status.actionsCount,
            loading: status.loading,
        });
    }

    render() {

        var initialLoading = false;
        var value = null;
        var unit = "Fetching New Starters Actions...";
        
        if (!this.state.loading) {
            unit = (
                <WidgetHeading
                    label="New Starters"
                    subText="Actions Required"
                />
            );
            value = this.state.count;
        }

        return (
            <PageSection
                id="new-starters-widget"
                backgroundColorClass="background-color-people"
                link="teams/new-starters/"
            >
                <WidgetCount 
                    iconName="icon-add-person" 
                    value={value} 
                    unit={unit}
                />
            </PageSection>
        );
    }
}

NewStartersWidget.propTypes = propTypes;

export default NewStartersWidget; 